let handlers = [];

export default function setupScrollWatch(){
    let handler = function() {
        for(let handle of handlers){

            if(handle.started){
                continue;
            }

            let element = handle.element ?? document.getElementById(handle.elementId);
            if(element){
                let y = element.getBoundingClientRect().y
                if(y > 5 && y < window.innerHeight - 5){
                    handle['started'] = true;
                    try{
                        handle.action();
                    } catch (e){
                        console.error(e);
                    }
                }
            }
        }
    };
    window.addEventListener('scroll', handler);
    window.addEventListener('resize', handler);
    window.addEventListener('DOMContentLoaded', handler);

    window['onScrollTo'] = onScrollTo;
    window['onScrollToEl'] = onScrollToEl;
}


function onScrollTo(elementId, action){
    handlers.push({
        'elementId':elementId, 'action':action, started:false
    });
}
function onScrollToEl(element, action){
    handlers.push({
        'element':element, 'action':action, started:false
    });
}
